"use client";
import React from "react";
import { AnimatedTooltip } from "@/components/ui/animated-tooltip";

const people = [
  {
    id: 1,
    name: "Sarah Mitchell",
    designation: "VP of Sales, NordTech",
    image: "https://i.pravatar.cc/150?img=47",
  },
  {
    id: 2,
    name: "Marcus Weber",
    designation: "Sales Director, Apex Solutions",
    image: "https://i.pravatar.cc/150?img=12",
  },
  {
    id: 3,
    name: "Lena Hoffmann",
    designation: "SDR Team Lead, Scalify",
    image: "https://i.pravatar.cc/150?img=25",
  },
  {
    id: 4,
    name: "James Okafor",
    designation: "Head of BDR, GrowthLoop",
    image: "https://i.pravatar.cc/150?img=15",
  },
  {
    id: 5,
    name: "Anna Bergström",
    designation: "Call Center Manager, Vantrix",
    image: "https://i.pravatar.cc/150?img=44",
  },
  {
    id: 6,
    name: "Tom Richter",
    designation: "Account Executive, LeadBridge",
    image: "https://i.pravatar.cc/150?img=33",
  },
];

export function FeaturedTestimonials() {
  return (
    <div className="flex flex-row items-center justify-center mb-10 w-full">
      <AnimatedTooltip items={people} />
    </div>
  );
}
